import { AddIcon, CloseIcon, PlayCircle, StopCircle } from '@sketchnote/icons';
import { Vec } from '@tldraw/vec';
import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useTldrawApp } from 'sn-wb-tldraw';

export function Timer({ shapes }: any) {
  const app = useTldrawApp();

  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(10);
  const [isRunning, setRunning] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [timerId, setTimerId] = useState(0);
  const [isFocused, setIsFocused] = useState(false);
  const tickAudio = useMemo(
    () =>
      new Audio('https://res.cloudinary.com/samvibes/video/upload/whiteboard-timer/end_timer.mp3'),
    []
  );
  const completeAudio = useMemo(
    () =>
      new Audio(
        'https://res.cloudinary.com/samvibes/video/upload/whiteboard-timer/timer_completed.mp3'
      ),
    []
  );
  const startAudio = useMemo(
    () =>
      new Audio(
        'https://res.cloudinary.com/samvibes/video/upload/whiteboard-timer/start_timer.mp3'
      ),
    []
  );

  const handleMinutes = (e) => {
    if (+e.target.value >= 0 && +e.target.value <= 99) setMinutes(+e.target.value);
    setIsComplete(false);
  };

  const handelSeconds = (e) => {
    if (+e.target.value >= 0 && +e.target.value <= 59) setSeconds(+e.target.value);
    setIsComplete(false);
  };

  const handleMinuteKey = (e) => {
    if (e.keyCode == '38') {
      // up arrow
      setMinutes((prev) => {
        if (prev >= 0 && prev < 99) {
          return prev + 1;
        } else {
          return prev;
        }
      });
    } else if (e.keyCode == '40') {
      // down arrow
      setMinutes((prev) => {
        if (prev > 0 && prev <= 99) {
          return prev - 1;
        } else {
          return prev;
        }
      });
    }
  };

  const handleSecondKey = (e) => {
    if (e.keyCode == '38') {
      // up arrow
      setSeconds((prev) => {
        if (prev >= 0 && prev < 59) {
          return prev + 1;
        } else {
          return prev;
        }
      });
    } else if (e.keyCode == '40') {
      // down arrow
      setSeconds((prev) => {
        if (prev > 0 && prev <= 59) {
          return prev - 1;
        } else {
          return prev;
        }
      });
    }
  };

  useEffect(() => {
    let timer;
    if (isRunning) {
      timer = setInterval(() => {
        setSeconds((prevSecond) => {
          const newSecond = prevSecond - 1;
          if (newSecond < 0) {
            setMinutes((prevMinute) => {
              const newMinute = prevMinute - 1;
              if (newMinute < 0) {
                setSeconds(0);
                setRunning(false);
                return 0;
              } else {
                return newMinute;
              }
            });
            return 59;
          } else {
            return newSecond;
          }
        });
      }, 1000);
      setTimerId(timer);
    } else {
      clearInterval(timerId);
    }
  }, [isRunning]);

  const handleStartTimer = () => {
    setRunning(true);
    startAudio.play();
  };

  useEffect(() => {
    if (!isRunning) return;
    if (minutes > 0) return;
    if (seconds > 5) return;
    if (seconds > 0) {
      tickAudio.play();
    }
    if (seconds === 0) {
      completeAudio.play();
      setIsComplete(true);
      setRunning(false);
    }
  }, [seconds, minutes]);

  return (
    <div
      className="z-100 bg-white px-12 py-10 "
      style={{
        position: 'absolute',
        top: '8%',
        right: '1.5%',
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        minWidth: '233px',
        border: 'none',
        outline: 'none',
        pointerEvents: 'all',
        width: '233px',
        boxShadow: '0px 2px 16px rgba(19, 23, 32, 0.12)',
        borderRadius: '8px',
      }}
    >
      <div className="flex justify-between items-center mb-10">
        <h3 className="font-medium text-base text-gray-600">Add a timer</h3>

        <CloseIcon
          className="cursor-pointer transform scale-70"
          fill="#878A92"
          onClick={() => {
            if (isRunning) {
              setRunning(false);
            }
            app.setTimer(false);
          }}
        />
      </div>
      <div className="flex items-center mb-16 text-5xl font-bold">
        {isRunning ? (
          <StopCircle
            onClick={() => setRunning(false)}
            className="mr-16 cursor-pointer hover:opacity-75"
          />
        ) : isComplete ? (
          <>
            <img
              className="mr-16 w-32"
              src="https://res.cloudinary.com/samvibes/image/upload/whiteboard-timer/confirmation-tick.gif"
            />
          </>
        ) : (
          <PlayCircle
            onClick={handleStartTimer}
            className="mr-16 cursor-pointer hover:opacity-75"
          />
        )}
        {!isRunning ? (
          <input
            type="text"
            className={cn(' text-gray-999 font-bold  w-51', {
              ' ': isFocused,
            })}
            onChange={handleMinutes}
            onFocus={() => setIsFocused(true)}
            value={minutes < 10 ? '0' + minutes : minutes}
            onKeyDown={handleMinuteKey}
          />
        ) : (
          <span className="text-gray-500">{minutes < 10 ? '0' + minutes : minutes}</span>
        )}

        <span className="text-primary-500">:</span>
        {!isRunning ? (
          <input
            type="text"
            className={cn(' text-gray-999 font-bold  w-52', {
              ' ': isFocused,
            })}
            value={seconds < 10 ? '0' + seconds : seconds}
            onChange={handelSeconds}
            onFocus={() => setIsFocused(true)}
            onKeyDown={handleSecondKey}
          />
        ) : (
          <span className="text-gray-500">{seconds < 10 ? '0' + seconds : seconds}</span>
        )}
      </div>
      <div className="text-sm text-gray-600 flex justify-between font-medium cursor-pointer">
        <div
          className="flex items-center"
          onClick={() => setMinutes((prev) => (prev < 99 ? prev + 1 : prev))}
        >
          <AddIcon className="mr-4 transform scale-70" fill="#55585E" />
          <span>1 min</span>
        </div>
      </div>
    </div>
  );
}
